import CreateSampleProjectCallout from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/Areas/Projects/components/CreateSampleProjectCallout/CreateSampleProjectCallout";

export default CreateSampleProjectCallout;
